import { render } from "./BaseDatePicker.vue?vue&type=template&id=477bbf5c"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js"

import "./BaseDatePicker.vue?vue&type=style&index=0&id=477bbf5c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__